import { useLocalStorage } from '@/core/shared/composition-helpers';
import store from '@/core/store';

export default function useTaxForm () {
  const userId = store.getters.currentOrganization.id;
  const hasSkippedTaxForm = useLocalStorage(`hasSkippedTaxForm-${userId}`);
  return {
    hasSkippedTaxForm,
  };
}
